<template>
  <div>
    <div class="el-card box-card is-always-shadow">
      <div class="el-card__header clearfix">
        <span> <i class="el-icon-search"></i> 検索 </span>
        <el-switch style="float: right" v-model="search"></el-switch>
      </div>
      <div class="el-card__body" v-if="search">
        <div class="search-form">
          <table class="table table-bordered">
            <tr>
              <th>お名前</th>
              <td>
                <el-input v-model="form.name" style="width: 250px"></el-input>
                <span>（漢字または、カナ）</span>
              </td>
            </tr>
            <tr>
              <th>会員番号</th>
              <td>
                <el-input v-model="form.local_customer_id" style="width: 250px"></el-input>
                <span>ex:123456</span>
              </td>
            </tr>
            <tr>
              <th>承認番号</th>
              <td>
                <el-input v-model="form.approval_number" style="width: 250px"></el-input>
                <span>ex:123456</span>
              </td>
            </tr>
            <tr>
              <th>受付番号</th>
              <td>
                <el-input v-model="form.id" style="width: 250px"></el-input>
                <span>ex:123456</span>
              </td>
            </tr>
            <tr>
              <th>顧客電話番号</th>
              <td>
                <el-input v-model="form.customer_tel" style="width: 250px"></el-input>
              </td>
            </tr>
            <tr>
              <th>状態</th>
              <td>
                <el-checkbox-group v-model="form.status" size="small">
                  <el-checkbox-button label="1000">{{ contractStatusText.status_1000 }}</el-checkbox-button>
                  <el-checkbox-button label="2000">{{ contractStatusText.status_2000 }}</el-checkbox-button>
                  <el-checkbox-button label="3000">{{ contractStatusText.status_3000 }}</el-checkbox-button>
                  <el-checkbox-button label="4000">{{ contractStatusText.status_4000 }}</el-checkbox-button>
                  <!-- <el-checkbox-button label="5000">架電待ち</el-checkbox-button> -->
                  <el-checkbox-button label="6000">{{ contractStatusText.status_6000 }}</el-checkbox-button>
                  <el-checkbox-button label="7000">{{ contractStatusText.status_7000 }}</el-checkbox-button>
                  <el-checkbox-button label="8000">{{ contractStatusText.status_8000 }}</el-checkbox-button>
                  <el-checkbox-button label="9000">{{ contractStatusText.status_9000 }}</el-checkbox-button>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <th>申込日</th>
              <td>
                <el-date-picker
                  v-model="form.apply_date"
                  type="datetimerange"
                  range-separator="-"
                  :editable="false"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  popper-class="search-calendar"
                ></el-date-picker>
              </td>
            </tr>
            <tr>
              <th>受付日</th>
              <td>
                <el-date-picker
                  v-model="form.reception_date"
                  type="datetimerange"
                  range-separator="-"
                  :editable="false"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  popper-class="search-calendar"
                ></el-date-picker>
              </td>
            </tr>
            <tr>
              <th>立替依頼日 / 契約依頼日</th>
              <td>
                <el-date-picker
                  v-model="form.tatekae_apply_at"
                  type="datetimerange"
                  range-separator="-"
                  :editable="false"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  popper-class="search-calendar"
                ></el-date-picker>
              </td>
            </tr>
            <tr v-if="!isBranch">
              <th>店舗</th>
              <td>
                <el-select v-model="form.store">
                  <el-option label="---" value></el-option>
                  <el-option
                    v-for="(item, index) in storeList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </td>
            </tr>
          </table>
          <div class="search-btn text-center">
            <el-button @click="searchClear"> <i class="el-icon-minus"></i> クリア </el-button>
            <el-button @click="searchTabs" type="success"> <i class="el-icon-search"></i> 検索する </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- unliadingArea -->
    <div class="unreading_area" v-if="unreading">
      <div class="unreading">
        チャット未読件数が{{ badge.unreadCount }}件あります。<el-button
          size="mini"
          type="danger"
          @click="activeList = 'ticket'"
          >確認する</el-button
        >
      </div>
    </div>

    <!-- listArea -->
    <div class="table-area" v-loading="loadingAllList">
      <!-- <el-button class="reload_btn" size="small" icon="el-icon-refresh" @click="refresh"></el-button> -->
      <el-tabs type="border-card" v-model="activeList" @tab-click="changeTab">
        <el-tab-pane name="credit" v-if="tabVisibleState.credit">
          <span slot="label"> 【信販】申込者一覧 </span>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>状態</th>
                <th>承認日</th>
                <th>保留理由</th>
                <th>お支払い方法</th>
                <th>キャンセル</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.credit" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>{{ row.apply_date }}<br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span></td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge :type="row.has_payment === 'credit' ? 'primary' : 'success'">
                    {{ row.has_payment === 'credit' ? '信販' : '自社割賦' }}
                  </badge>
                </td>
                <td>{{ row.status }}</td>
                <td v-if="row.contract_status == 9000">
                  {{ row.cancel_complete }}
                </td>
                <td v-else-if="row.contract_status == 4000">
                  {{ row.denial_at }}
                </td>
                <td v-else>{{ row.agree_at }}</td>
                <td>{{ row.pending_text }}</td>
                <td>{{ row.product }}</td>
                <td>{{ row.cancel }}</td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="text-center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="meta.credit.total"
              :page-size="meta.credit.size"
              :current-page="meta.credit.currentPage"
              @current-change="currentChange"
            ></el-pagination>
          </div>

          <div class="table-area__total">
            <TotalTable :count="meta.credit.total" :price="meta.credit.remaining_money_total"></TotalTable>
          </div>
          <hr />
          <div class="excel_area text-right">
            <el-button type="info" @click="downloadListExcel('credit')">申込一覧データをEXCELでダウンロード</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane name="replacement" v-if="isTatekaelable && tabVisibleState.replacement">
          <span slot="label">
            【信販】立替依頼
            <span class="badge badge-warning" v-if="badge.exclutionCount > 0">
              除外:
              <template v-if="badge.exclutionCount >= 100">99+</template>
              <template v-else>{{ badge.exclutionCount }}件</template>
            </span>
            <span class="badge badge-info" style="color: #fff" v-if="tatekaeUnApplyCount > 0">
              未依頼:
              <template v-if="tatekaeUnApplyCount >= 100">99+</template>
              <template v-else>{{ tatekaeUnApplyCount }}件</template>
            </span>
          </span>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>承認日</th>
                <th>お支払い方法</th>
                <!-- <th>キャンセル</th> -->
                <th>立替除外</th>
                <th>立替依頼日</th>
                <th>立替締日</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.replacement" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>
                  {{ row.apply_date }}
                  <br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span>
                </td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge :type="row.has_payment === 'credit' ? 'primary' : 'success'">
                    {{ row.has_payment === 'credit' ? '信販' : '自社割賦' }}
                  </badge>
                </td>
                <td v-if="row.contract_status == 9000">
                  {{ row.cancel_complete }}
                </td>
                <td v-else-if="row.contract_status == 4000">
                  {{ row.denial_at }}
                </td>
                <td v-else>{{ row.agree_at }}</td>
                <td>{{ row.product }}</td>
                <td class="text-center">
                  <el-checkbox
                    v-if="!row.tatekae_apply"
                    :disabled="applyBtnLoading"
                    v-model="row.is_exclusion"
                    @change="changeExclusion(row, $event)"
                  ></el-checkbox>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.tatekae_apply }}</span>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.closing_date }}</span>
                </td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="table-area__total">
            <TotalTable :count="meta.replacement.total" :price="meta.replacement.remaining_money_total"></TotalTable>
          </div>

          <div class="text-center" v-if="isTatekaelable">
            <el-button :loading="applyBtnLoading" type="warning" @click="replacementDialog = true"
              >立替依頼する</el-button
            >
          </div>

          <hr />
          <div class="excel_area text-right">
            <el-button type="info" @click="downloadListExcel('replacement')"
              >立替依頼済みデータをEXCELでダウンロード</el-button
            >
          </div>

          <el-dialog title="立替依頼する" :visible.sync="replacementDialog" width="80%">
            <span>立替除外をチェックされていないお申込みすべてを立替依頼します</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="replacementDialog = false" :disabled="isLoadingTatekaeApply">戻る</el-button>
              <el-button type="danger" @click="tatekaeApply" :loading="isLoadingTatekaeApply">立替依頼する</el-button>
            </span>
          </el-dialog>
        </el-tab-pane>

        <el-tab-pane name="tatekae_complete" v-if="isTatekaelable && tabVisibleState.tatekae_complete">
          <span slot="label">【信販】立替済</span>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>承認日</th>
                <th>お支払い方法</th>
                <th>立替依頼日</th>
                <th>立替締日</th>
                <th>送金日</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.tatekae_complete" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>
                  {{ row.apply_date }}
                  <br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span>
                </td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge type="primary">信販</badge>
                </td>
                <td>{{ row.agree_at }}</td>
                <td>{{ row.product }}</td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.tatekae_apply }}</span>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.closing_date }}</span>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.sending_date }}</span>
                </td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="table-area__total">
            <TotalTable
              :count="meta.tatekae_complete.total"
              :price="meta.tatekae_complete.remaining_money_total"
            ></TotalTable>
          </div>

          <hr />
          <div class="excel_area text-right">
            <el-button type="info" @click="downloadListExcel('tatekae_complete')"
              >立替済みデータをEXCELでダウンロード</el-button
            >
          </div>
        </el-tab-pane>

        <el-tab-pane name="installment" v-if="tabVisibleState.installment">
          <span slot="label"> 【自社割賦】申込者一覧 </span>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>状態</th>
                <th>承認日</th>
                <th>保留理由</th>
                <th>お支払い方法</th>
                <th>キャンセル</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.installment" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>{{ row.apply_date }}<br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span></td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge :type="row.has_payment === 'credit' ? 'primary' : 'success'">
                    {{ row.has_payment === 'credit' ? '信販' : '自社割賦' }}
                  </badge>
                </td>
                <td>{{ row.status }}</td>
                <td v-if="row.contract_status == 9000">
                  {{ row.cancel_complete }}
                </td>
                <td v-else-if="row.contract_status == 4000">
                  {{ row.denial_at }}
                </td>
                <td v-else>{{ row.agree_at }}</td>
                <td>{{ row.pending_text }}</td>
                <td>{{ row.product }}</td>
                <td>{{ row.cancel }}</td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="text-center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="meta.installment.total"
              :page-size="meta.installment.size"
              :current-page="meta.installment.currentPage"
              @current-change="currentChange"
            ></el-pagination>
          </div>

          <div class="table-area__total">
            <TotalTable :count="meta.installment.total" :price="meta.installment.remaining_money_total"></TotalTable>
          </div>

          <hr />

          <div class="excel_area text-right">
            <el-button type="info" @click="downloadListExcel('installment')"
              >申込一覧データをEXCELでダウンロード</el-button
            >
          </div>
        </el-tab-pane>

        <el-tab-pane
          name="scheduled_installment"
          v-if="isInstallmentRequestable && tabVisibleState.scheduled_installment"
        >
          <span slot="label">
            【自社割賦】契約依頼
            <span class="badge badge-warning" v-if="badge.scheduledInstallmentExclutionCount > 0">
              除外:
              <template v-if="badge.scheduledInstallmentExclutionCount >= 100">99+</template>
              <template v-else>{{ badge.scheduledInstallmentExclutionCount }}件</template>
            </span>
            <span class="badge badge-info" style="color: #fff" v-if="installmentRequestedUnApplyCount > 0">
              未依頼:
              <template v-if="installmentRequestedUnApplyCount >= 100">99+</template>
              <template v-else>{{ installmentRequestedUnApplyCount }}件</template>
            </span>
          </span>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>承認日</th>
                <th>お支払い方法</th>
                <th>契約除外</th>
                <th>契約依頼日</th>
                <th>契約締日</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.scheduled_installment" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>
                  {{ row.apply_date }}
                  <br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span>
                </td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge :type="row.has_payment === 'credit' ? 'primary' : 'success'">
                    {{ row.has_payment === 'credit' ? '信販' : '自社割賦' }}
                  </badge>
                </td>
                <td v-if="row.contract_status == 9000">
                  {{ row.cancel_complete }}
                </td>
                <td v-else-if="row.contract_status == 4000">
                  {{ row.denial_at }}
                </td>
                <td v-else>{{ row.agree_at }}</td>
                <td>{{ row.product }}</td>
                <td class="text-center">
                  <el-checkbox
                    v-if="!row.tatekae_apply"
                    :disabled="applyBtnLoading"
                    v-model="row.is_exclusion"
                    @change="changeExclusion(row, $event)"
                  ></el-checkbox>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.tatekae_apply }}</span>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.closing_date }}</span>
                </td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="table-area__total">
            <TotalTable
              :count="meta.scheduled_installment.total"
              :price="meta.scheduled_installment.remaining_money_total"
            ></TotalTable>
          </div>

          <div class="text-center" v-if="isInstallmentRequestable">
            <el-button :loading="applyBtnLoading" type="warning" @click="scheduledInstallmentDialog = true"
              >契約依頼する</el-button
            >
          </div>

          <hr />
          <div class="excel_area text-right">
            <el-button type="info" @click="downloadListExcel('scheduled_installment')"
              >契約依頼済みデータをEXCELでダウンロード</el-button
            >
          </div>

          <el-dialog title="契約依頼する" :visible.sync="scheduledInstallmentDialog" width="80%">
            <span>契約除外をチェックされていないお申込みすべてを契約依頼します</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="scheduledInstallmentDialog = false" :disabled="isLoadingScheduledInstallmentApply"
                >戻る</el-button
              >
              <el-button type="danger" @click="scheduledInstallmentApply" :loading="isLoadingScheduledInstallmentApply"
                >契約依頼する</el-button
              >
            </span>
          </el-dialog>
        </el-tab-pane>

        <el-tab-pane
          name="installment_complete"
          v-if="isInstallmentRequestable && tabVisibleState.installment_complete"
        >
          <span slot="label">【自社割賦】契約済</span>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>承認日</th>
                <th>お支払い方法</th>
                <th>立替依頼日</th>
                <th>立替締日</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.installment_complete" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>
                  {{ row.apply_date }}
                  <br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span>
                </td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge type="primary">信販</badge>
                </td>
                <td>{{ row.agree_at }}</td>
                <td>{{ row.product }}</td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.tatekae_apply }}</span>
                </td>
                <td>
                  <span v-if="row.tatekae_apply">{{ row.closing_date }}</span>
                </td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="table-area__total">
            <TotalTable
              :count="meta.installment_complete.total"
              :price="meta.installment_complete.remaining_money_total"
            ></TotalTable>
          </div>

          <hr />
          <div class="excel_area text-right">
            <el-button type="info" @click="downloadListExcel('installment_complete')"
              >契約済みデータをEXCELでダウンロード</el-button
            >
          </div>
        </el-tab-pane>

        <el-tab-pane name="cancel" v-if="tabVisibleState.cancel">
          <span slot="label"> キャンセル依頼中 </span>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>キャンセル依頼日</th>
                <th>お支払い方法</th>
                <th>立替状態</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.cancel" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>
                  {{ row.apply_date }}
                  <br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span>
                </td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge :type="row.has_payment === 'credit' ? 'primary' : 'success'">
                    {{ row.has_payment === 'credit' ? '信販' : '自社割賦' }}
                  </badge>
                </td>
                <td>{{ row.cancel_request }}</td>
                <td>{{ row.product }}</td>
                <td>
                  <template v-if="row.is_exclusion">立替除外</template>
                </td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="text-center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="meta.cancel.total"
              :page-size="meta.cancel.size"
              :current-page="meta.cancel.currentPage"
              @current-change="currentChange"
            ></el-pagination>
          </div>

          <div class="table-area__total">
            <TotalTable :count="meta.cancel.total" :price="meta.cancel.remaining_money_total"></TotalTable>
          </div>
        </el-tab-pane>

        <el-tab-pane name="ticket" v-if="tabVisibleState.ticket">
          <span slot="label">
            チャット未読リスト
            <span class="badge badge-danger" v-if="badge.unreadCount > 0">
              <template v-if="badge.unreadCount >= 100">99+</template>
              <template v-else>{{ badge.unreadCount }}件</template>
            </span>
          </span>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>会員番号</th>
                <th>承認番号</th>
                <th>受付番号</th>
                <th>申込日</th>
                <th>会員氏名</th>
                <th>申込金額</th>
                <th>形式</th>
                <th>状態</th>
                <th>承認日</th>
                <th>保留理由</th>
                <th>お支払い方法</th>
                <th>店舗名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in lists.ticket" :key="index" :class="row.class">
                <td>{{ row.number }}</td>
                <td>{{ row.approval_number }}</td>
                <td>
                  {{ row.id }}
                  <div><a href="#" @click.prevent="showDetail(row.id)"><i class="el-icon-edit" />編集/写真追加/チャット</a></div>
                </td>
                <td>
                  {{ row.apply_date }}
                  <br v-if="row.is_beri" /><span v-if="row.is_beri" class="created_at_text fc-red">{{ row.beri_text }}</span>
                </td>
                <td>
                  <span>{{ row.name }}</span>
                  <br />
                  <span class="fz-11">{{ row.name_kana }}</span>
                </td>
                <td>{{ row.money }}</td>
                <td>
                  <badge :type="row.has_payment === 'credit' ? 'primary' : 'success'">
                    {{ row.has_payment === 'credit' ? '信販' : '自社割賦' }}
                  </badge>
                </td>
                <td>{{ row.status }}</td>
                <td v-if="row.contract_status == 9000">
                  {{ row.cancel_complete }}
                </td>
                <td v-else-if="row.contract_status == 4000">
                  {{ row.denial_at }}
                </td>
                <td v-else>{{ row.agree_at }}</td>
                <td>{{ row.hold }}</td>
                <td>{{ row.product }}</td>
                <td>{{ row.company_name }}</td>
              </tr>
            </tbody>
          </table>

          <div class="text-center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="meta.ticket.total"
              :page-size="meta.ticket.size"
              :current-page="meta.ticket.currentPage"
              @current-change="currentChange"
            ></el-pagination>
          </div>

          <div class="table-area__total">
            <TotalTable :count="meta.ticket.total" :price="meta.ticket.remaining_money_total"></TotalTable>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title="申込一覧データ EXCELダウンロード" :visible.sync="overCountDialog" width="30%">
      <span>表示件数の上限を超えています。<br>検索を行なって1500件以下になるようにしてください。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="overCountDialog = false">はい</el-button>
      </span>
    </el-dialog>

    <transition name="from-right">
      <router-view @back="refresh"></router-view>
    </transition>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ContractStatusText} from '@/js/util/constants.js'
import Badge from '@/js/components/common/Atoms/Badge.vue'
import TotalTable from '@/js/components/common/Molecules/TotalTable.vue'
export default {
  components: {
    Badge,
    TotalTable
  },
  data() {
    return {
      applyBtnLoading: false,
      intervalId: null,
      tabs: [
        'installment',
        'credit',
        'replacement',
        'tatekae_complete',
        'scheduled_installment',
        'installment_complete',
        'cancel',
        'ticket'
      ],
      /** タブの表示状態 **/
      tabVisibleState: {
        credit: false,
        replacement: false,
        tatekae_complete: false,
        installment: false,
        scheduled_installment: false,
        installment_complete: false,
        cancel: true,
        ticket: true
      },
      search: false,
      replacementDialog: false,
      scheduledInstallmentDialog: false,
      isLoadingTatekaeApply: false,
      isLoadingScheduledInstallmentApply: false,
      formCache: {},
      form: {
        id: '',
        name: '',
        approval_number: '',
        local_customer_id: '',
        status: [],
        apply_date: [],
        reception_date: [],
        tatekae_apply_at: [],
        store: '',
        customer_tel: ''
      },
      searchParams: {
        id: '',
        name: '',
        approval_number: '',
        local_customer_id: '',
        status: [],
        apply_date: [],
        reception_date: [],
        tatekae_apply_at: [],
        store: '',
        customer_tel: ''
      },
      storeList: [],

      activeList: 'credit',
      badge: {
        exclutionCount: 0,
        scheduledInstallmentExclutionCount: 0,
        unreadCount: 0
      },
      lists: {
        installment: [],
        credit: [],
        replacement: [],
        tatekae_complete: [],
        scheduled_installment: [],
        installment_complete: [],
        cancel: [],
        ticket: []
      },
      meta: {
        installment: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        credit: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        tatekae_complete: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        replacement: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        scheduled_installment: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        installment_complete: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        cancel: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        },
        ticket: {
          total: null,
          size: null,
          currentPage: 1,
          remaining_money_total: null,
          loaded: false
        }
      },
      contractStatusText: ContractStatusText,
      overCountDialog: false
    }
  },
  created() {
    // タブ初期表示
    if (this.isCreditServiceable) {
      this.activeList = 'credit'
    } else if (this.isInstallmentServiceable) {
      this.activeList = 'installment'
    } else {
      this.activeList = 'ticket'
    }
    this.tabVisibleState.credit = this.isCreditServiceable
    this.tabVisibleState.replacement = this.isCreditServiceable
    this.tabVisibleState.tatekae_complete = this.isCreditServiceable
    this.tabVisibleState.installment = this.isInstallmentServiceable
    this.tabVisibleState.scheduled_installment = this.isInstallmentServiceable
    this.tabVisibleState.installment_complete = this.isInstallmentServiceable
  },
  mounted() {
    this.initialize()
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    initialize() {
      this.formCache = Vue.util.extend({}, this.form)
      axios.get('/api/store/').then((res) => {
        this.storeList = res.data
      })
      this.refresh()

      this.getVisibleState()

      // 分毎に全データ更新
      this.intervalId = this.setInterval = setInterval(() => {
        this.refresh()
      }, 1000 * 60)
    },
    getVisibleState() {
      for (let tab of ['credit', 'replacement', 'installment', 'scheduled_installment', 'tatekae_complete', 'installment_complete']) {
        axios.get(`/api/store/contract/${tab}/is-visible`).then((res) => {
          if (res.data > 0) {
            this.tabVisibleState[tab] = true
          }
          // 信販 申込者が0の場合 自社割賦タブを初期表示にする
          if (tab === 'credit' && res.data === 0) {
            this.activeList = 'installment'
          }
        })
      }
    },
    load(tab) {
      const params = {...this.searchParams}
      params.page = this.meta[tab].currentPage
      //値を取得
      axios
        .get(`/api/store/contract/${tab}/index`, {
          params
        })
        .then((res) => {
          this.lists[tab] = res.data.data
          this.meta[tab]['total'] = res.data.total
          this.meta[tab]['size'] = res.data.per_page
          this.meta[tab]['remaining_money_total'] = res.data.remaining_money_total
          this.meta[tab]['loaded'] = true

          for (let key in this.badge) {
            if (typeof res.data[key] == 'number') {
              this.badge[key] = res.data[key]
            }
          }
        })
    },
    refresh() {
      for (let tab of this.tabs) {
        this.load(tab)
      }
    },
    searchTabs() {
      const tabs = this.tabs
      this.searchParams = Vue.util.extend({}, this.form)
      for (let tab of tabs) {
        this.meta[tab].currentPage = 1
        this.load(tab)
      }
    },

    searchClear() {
      this.form = Vue.util.extend({}, this.formCache)
      this.searchTabs()
    },

    showDetail(id) {
      if (this.$route.name !== 'list-detail') {
        this.$router.push({name: 'list-detail', params: {id: id}})
      }
    },
    currentChange(page) {
      // ページネーション
      const tab = this.activeList
      this.meta[tab].currentPage = page
      this.load(tab)
    },
    downloadReplacement() {
      const url = '/api/store/contract/replacement/download'
      const parmStr = new URLSearchParams(this.searchParams).toString()
      location.href = url + '?' + parmStr
    },
    downloadScheduledInstallment() {
      const url = '/api/store/contract/scheduled-installment/download'
      const parmStr = new URLSearchParams(this.searchParams).toString()
      location.href = url + '?' + parmStr
    },
    downloadListExcel(scope) {
      if(this.meta[this.activeList]['total'] > 1500){
        this.overCountDialog = true
        return
      }
      const url = `/api/store/contract/${scope}/downloadExcel`
      const parmStr = new URLSearchParams(this.searchParams).toString()
      location.href = url + '?' + parmStr
    },
    tatekaeApply() {
      // 立替依頼するリストを抽出
      this.isLoadingTatekaeApply = true
      const applyReplacement = this.lists.replacement
        .filter((rep) => rep.tatekae_apply === '')
        .map((rep) => {
          return {id: rep.id, is_exclusion: rep.is_exclusion}
        })
      axios
        .put('/api/store/contract/replacement/apply', {applyReplacement})
        .then((res) => {
          this.load(this.activeList)
          this.isLoadingTatekaeApply = false
          this.replacementDialog = false
        })
        .catch((err) => {})
    },
    scheduledInstallmentApply() {
      // 契約依頼するリストを抽出
      this.isLoadingScheduledInstallmentApply = true
      const applyReplacement = this.lists.scheduled_installment
        .filter((rep) => rep.tatekae_apply === '')
        .map((rep) => {
          return {id: rep.id, is_exclusion: rep.is_exclusion}
        })
      axios
        .put('/api/store/contract/scheduled-installment/apply', {
          applyReplacement
        })
        .then((res) => {
          this.load(this.activeList)
          this.isLoadingScheduledInstallmentApply = false
          this.scheduledInstallmentDialog = false
        })
        .catch((err) => {})
    },
    changeExclusion(row, $event) {
      console.log($event)
      if (this.applyBtnLoading) {
        return
      }
      this.applyBtnLoading = true
      axios
        .put('/api/store/contract/replacement/changeStatus/' + row.id, {
          is_exclusion: $event
        })
        .then((res) => {
          // バッチの数を抽出
          if (row.has_payment === 'credit') {
            this.badge.exclutionCount = this.lists.replacement.filter((rep) => rep.is_exclusion).length
          }

          if (row.has_payment === 'installment') {
            this.badge.scheduledInstallmentExclutionCount = this.lists.scheduled_installment.filter(
              (rep) => rep.is_exclusion
            ).length
          }

          this.applyBtnLoading = false
        })
        .catch((err) => {
          this.applyBtnLoading = false
        })
    },
    changeTab() {
      this.load(this.activeList)
    },
    initializeActiveTab() {}
  },
  computed: {
    ...mapGetters({
      isBranch: 'auth/isBranch'
    }),
    tatekaeUnApplyCount() {
      return this.lists.replacement.filter((rep) => rep.tatekae_apply === '').length
    },
    installmentRequestedUnApplyCount() {
      return this.lists.scheduled_installment.filter((rep) => rep.tatekae_apply === '').length
    },
    isTatekaelable() {
      return this.$store.state.auth.user.tatekaelable
    },
    isInstallmentRequestable() {
      return this.$store.state.auth.user.installment_requestable
    },
    isCreditServiceable() {
      return this.$store.state.auth.user.credit_serviceable
    },
    isInstallmentServiceable() {
      return this.$store.state.auth.user.installment_serviceable
    },
    loadingAllList() {
      for (let tab of this.tabs) {
        if (this.meta[tab]['loaded']) {
          return false
        }
      }

      return true
    },
    unreading() {
      return Boolean(this.badge.unreadCount)
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.table-area {
  margin-top: 15px;
  padding-top: 0;

  .table {
    th,
    td {
      padding: 5px;
      vertical-align: middle;
    }
    th {
      text-align: center;
    }
    th {
      font-size: 11px;
    }
    td {
      font-size: 12px;
    }
    tr.notice {
      td {
        background-color: #ffffc1;
      }
    }
    tr.fixed {
      td {
        background-color: #ecffe6;
      }
    }
  }
}
.table-area {
  position: relative;
  .reload_btn {
    border: 1px solid #ccc;
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 22px;
    width: 36px;
    height: 36px;
    text-align: center;
    border-radius: 4px;
    display: inline-block;
    z-index: 50;
    padding: 0;
    &:hover {
      background-color: #eee;
      border: 1px solid #aaa;
      cursor: pointer;
    }
  }
}
.unreading_area {
  margin-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
}
.unreading {
  padding: 10px 20px;
  border: 1px solid #ffa5a5;
  background-color: #ffe6e6;
  color: red;
  font-weight: bold;
  border-radius: 5px;
}
.table-area::v-deep {
  .created_at_text {
    font-size: 10px;
  }
}
</style>
